import {  Mail, Phone } from "lucide-react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faLinkedin, faYoutube, faPinterest } from '@fortawesome/free-brands-svg-icons';
import Logofooter from "../assets/WicunaTech_Logo_white.svg";
import  {Link} from "react-router-dom" ;

export default function Footer() {
  return (
    <footer className="bg-black text-white py-10 sm:py-16 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 sm:gap-12 mb-8 sm:mb-12">
          {/* Left Column - Company Info */}
          <div className="space-y-6">
            {/* Logo and Company Name */}
            <div className="flex items-center space-x-4">
              <div className="flex items-center justify-center">
                <img src={Logofooter} alt="Wicuna Technologies Logo - White" />
              </div>
            </div>

            {/* Company Description */}
            <p className="text-gray-300 leading-relaxed max-w-sm">
              Wicuna Technologies specializes in website development, design, graphic design, and consultancy,
              delivering innovative, user-centric digital solutions to empower businesses and enhance their online
              presence.
            </p>

            {/* Social Media Icons */}
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/wicunatech/" target="_blank" rel="noopener noreferrer"
                className="w-10 h-10 border border-gray-600 rounded flex items-center justify-center hover:bg-gray-800 transition-colors"
              >
                <FontAwesomeIcon icon={faFacebook} className="text-xl" />
              </a>
              <a
                href="https://www.instagram.com/wicunatech/" target="_blank" rel="noopener noreferrer"
                className="w-10 h-10 border border-gray-600 rounded flex items-center justify-center hover:bg-gray-800 transition-colors"
              >
                <FontAwesomeIcon icon={faInstagram} className="text-xl" />
              </a>
              <a
                href="https://www.linkedin.com/company/wicunatech/" target="_blank" rel="noopener noreferrer"
                className="w-10 h-10 border border-gray-600 rounded flex items-center justify-center hover:bg-gray-800 transition-colors"
              >
                <FontAwesomeIcon icon={faLinkedin} className="text-xl" />
              </a>
              <a
                href="https://www.youtube.com/@wicunatech" target="_blank" rel="noopener noreferrer"
                className="w-10 h-10 border border-gray-600 rounded flex items-center justify-center hover:bg-gray-800 transition-colors"
              >
                <FontAwesomeIcon icon={faYoutube} className="text-xl" />
              </a>

              <a
                href="https://in.pinterest.com/wicunatech/" target="_blank" rel="noopener noreferrer"
                className="w-10 h-10 border border-gray-600 rounded flex items-center justify-center hover:bg-gray-800 transition-colors"
              >
                <FontAwesomeIcon icon={faPinterest} className="text-xl" />
              </a>


            </div>
          </div>

          {/* Middle Column - Useful Links */}
          <div>
            <h4 className="text-xl font-semibold mb-6">Useful Links</h4>
            <nav className="space-y-4">
              <Link to="/" className="block text-gray-300 hover:text-white transition-colors">Home</Link>
              <Link to="/about" className="block text-gray-300 hover:text-white transition-colors">About us</Link>
              <Link to="/service" className="block text-gray-300 hover:text-white transition-colors">Services</Link> 
              <Link to="/client" className="block text-gray-300 hover:text-white transition-colors">Clients</Link>
              <Link to="/contact" className="block text-gray-300 hover:text-white transition-colors">Contact Us</Link>
              {/* <Link to="/blog" className="block text-gray-300 hover:text-white transition-colors">Blog</Link> */}
            </nav>
          </div>

          {/* Right Column - Contact Information */}
          <div>
            <h4 className="text-xl font-semibold mb-6">Contact Information</h4>

           <div className="space-y-4">
  
  {/* Email — opens mail app on click */}
  
  <a  href="mailto:wicunatech@gmail.com"
    className="flex items-center space-x-3 hover:opacity-80 transition-opacity"
  >
    <Mail className="w-5 h-5 text-gray-400" />
    <span className="text-gray-300">wicunatech@gmail.com</span>
  </a>

  {/* Phone — opens dialer on click */}
  
   <a href="tel:+918178909878"
    className="flex items-center space-x-3 hover:opacity-80 transition-opacity"
  >
    <Phone className="w-5 h-5 text-gray-400" />
    <span className="text-gray-300">+91 8178909878</span>
  </a>

</div>

          </div>
        </div>

        {/* Footer Bottom */}
        <div className="border-t border-gray-800 pt-8">
          <p className="text-center text-gray-400">
            Copyright 2026 Wicuna Technologies, All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
